module.exports = __webpack_public_path__ + "static/media/fastbite-details.366ec13b.jpg";